export default __webpack_public_path__ + "static/media/96.1f23c63a.jpg";